module.exports = __webpack_public_path__ + "img/logo-default-img.3c22a2a3.jpg";